import _ from 'lodash'
import { useCallback } from 'react'
import TagManager from 'react-gtm-module'
import { onBeginCheckout } from 'shared/gtm/onBeginCheckout'
import { ICourse } from 'stores/courses'

interface IActionButtonProps {
  klassId: string
  disabled: boolean
  name: string
  handler: () => void
  isMobile?: boolean
  course?: ICourse
}

const ActionButton = ({
  klassId,
  disabled,
  handler,
  name,
  isMobile = false,
  course,
}: IActionButtonProps) => {
  const className = !isMobile
    ? `flex justify-center items-center w-full mt-4 py-2.5 px-14 rounded 
      ${disabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-primary-normal'}`
    : `flex-1 block rounded-md font-semibold text-center py-2 text-white ${
        disabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-primary-normal'
      }`

  const actionHandler = useCallback(() => {
    if (klassId.includes('kdt')) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'kdt_apply_btn_click',
          content_ids: klassId,
          ...(sessionStorage.getItem('utmAndGclid') &&
            JSON.parse(sessionStorage.getItem('utmAndGclid') as string)),
        },
      })
    }
    if (course && ['event', 'worker'].includes(course.courseType)) {
      onBeginCheckout(course)
    }
    handler()
  }, [course, handler, klassId])

  return (
    <button disabled={disabled} onClick={actionHandler} className={className}>
      <span className="text-base font-semibold text-white md:text-lg">{name}</span>
    </button>
  )
}

export default ActionButton
